var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.76471 6.54545V4.36364C1.76471 1.95345 3.66071 0 6 0C8.33965 0 10.2353 1.95273 10.2353 4.36364V6.54545C10.7034 6.54545 11.1523 6.73706 11.4833 7.07812C11.8142 7.41917 12.0001 7.88173 12 8.364V14.1818C11.9994 15.1857 11.2097 15.9994 10.2353 16H1.76471C1.29662 16 0.847702 15.8084 0.516746 15.4673C0.185789 15.1263 -9.35474e-05 14.6637 3.53186e-08 14.1815V8.36364C0.000584172 7.35973 0.790328 6.54606 1.76471 6.54545ZM1.41176 8.364V14.1818C1.41176 14.3826 1.56978 14.5455 1.76471 14.5455H10.2353C10.4294 14.5455 10.5882 14.3818 10.5882 14.1815V8.36364C10.5882 8.16281 10.4302 8 10.2353 8H1.76471C1.57059 8 1.41176 8.16364 1.41176 8.364ZM8.82353 4.36364V6.54545H3.17647V4.36364C3.17647 2.75699 4.44061 1.45455 6 1.45455C7.56 1.45455 8.82353 2.756 8.82353 4.36364Z",
    fill: "#B6B8BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock4);
export default __webpack_public_path__ + "static/media/lock4.470aa0e0b976fd3c55fecc6753e896b5.svg";
export { ForwardRef as ReactComponent };